// Étape 16 — Page publique du lien personnel du consultant (/r/{code})
import { useState, useEffect } from "react";
import axios from "axios";
import { C, Btn, Input, Textarea, FormField, Alert, Spinner, LEAD_BESOINS, errMsg } from "./shared";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function LienPerso({ code }) {
  const [c, setC] = useState(null);
  const [err, setErr] = useState("");
  const [f, setF] = useState({ prenom: "", nom: "", telephone: "", email: "", besoin: "", message: "", rgpd: false, website: "" });
  const [sent, setSent] = useState(false);
  const [saving, setSaving] = useState(false);
  useEffect(() => { axios.get(`${API}/public/r/${code}`).then(r => setC(r.data)).catch(() => setErr("Ce lien n'est pas (ou plus) actif.")); }, [code]);
  const set = (k, v) => setF({ ...f, [k]: v });
  const ok = f.prenom.trim() && f.nom.trim() && (f.telephone.trim() || f.email.trim()) && f.besoin && f.rgpd;
  const submit = async () => {
    setSaving(true); setErr("");
    try { await axios.post(`${API}/public/r/${code}`, f); setSent(true); } catch (e) { setErr(errMsg(e)); } finally { setSaving(false); }
  };
  return (
    <div style={{ minHeight: "100vh", background: C.gray, fontFamily: "'Inter', sans-serif", color: C.text }}>
      <div style={{ background: C.navy, padding: "18px 24px" }}>
        <div style={{ fontFamily: "'Playfair Display', serif", fontSize: 22, color: "#fff", letterSpacing: ".04em" }}>AUPRÉA</div>
        <div style={{ fontSize: 11, color: C.gold, fontStyle: "italic" }}>vous accompagne</div>
      </div>
      <div style={{ maxWidth: 560, margin: "0 auto", padding: "28px 18px" }}>
        {!c && !err && <Spinner />}
        {err && !c && <Alert type="error"><span>⚠</span><span data-testid="lien-erreur">{err}</span></Alert>}
        {c && (
          <>
            <div style={{ display: "flex", gap: 16, alignItems: "center", marginBottom: 22 }} data-testid="lien-consultant">
              {c.photo ? <img src={c.photo} alt={c.nom} style={{ width: 78, height: 78, borderRadius: "50%", objectFit: "cover", border: `3px solid ${C.gold}` }} />
                : <div style={{ width: 78, height: 78, borderRadius: "50%", background: C.gold, color: C.navy, display: "grid", placeItems: "center", fontSize: 28, fontWeight: 700, fontFamily: "'Playfair Display', serif" }}>{(c.prenom || "?")[0]}</div>}
              <div>
                <div style={{ fontSize: 11, color: C.golddm, fontWeight: 700, textTransform: "uppercase", letterSpacing: ".08em" }}>Votre consultant AUPRÉA</div>
                <div style={{ fontSize: 22, fontWeight: 700, color: C.navy, fontFamily: "'Playfair Display', serif" }}>{c.nom}</div>
                {c.zone && <div style={{ fontSize: 12, color: C.mid }}>{c.zone}</div>}
              </div>
            </div>
            {sent ? (
              <div data-testid="lien-merci" style={{ background: "#fff", borderRadius: 14, border: `.5px solid ${C.border}`, padding: 28, textAlign: "center" }}>
                <div style={{ fontSize: 22, fontFamily: "'Playfair Display', serif", color: C.navy, marginBottom: 8 }}>Merci, votre demande est bien envoyée.</div>
                <div style={{ fontSize: 14, color: C.mid }}>{c.prenom} vous recontactera très rapidement.</div>
              </div>
            ) : (
              <div style={{ background: "#fff", borderRadius: 14, border: `.5px solid ${C.border}`, padding: 22 }}>
                <div style={{ fontSize: 16, fontWeight: 700, color: C.navy, marginBottom: 14 }}>Être recontacté(e)</div>
                {err && <Alert type="error"><span>⚠</span><span>{err}</span></Alert>}
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                  <FormField label="Prénom" required><Input value={f.prenom} onChange={(e) => set("prenom", e.target.value)} data-testid="lien-prenom" /></FormField>
                  <FormField label="Nom" required><Input value={f.nom} onChange={(e) => set("nom", e.target.value)} data-testid="lien-nom" /></FormField>
                  <FormField label="Téléphone"><Input type="tel" value={f.telephone} onChange={(e) => set("telephone", e.target.value)} data-testid="lien-tel" /></FormField>
                  <FormField label="E-mail"><Input type="email" value={f.email} onChange={(e) => set("email", e.target.value)} data-testid="lien-email" /></FormField>
                </div>
                <div style={{ height: 12 }} />
                <FormField label="Votre besoin" required>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 6 }}>
                    {LEAD_BESOINS.map(b => <button key={b} type="button" onClick={() => set("besoin", b)} data-testid={`lien-besoin-${b}`}
                      style={{ padding: 10, borderRadius: 8, border: f.besoin === b ? `2px solid ${C.gold}` : `1px solid ${C.border}`, background: f.besoin === b ? C.goldlt : "#fff", fontWeight: 600, fontSize: 12, cursor: "pointer", fontFamily: "inherit", color: C.navy }}>{b}</button>)}
                  </div>
                </FormField>
                <div style={{ height: 12 }} />
                <FormField label="Message"><Textarea value={f.message} onChange={(e) => set("message", e.target.value)} data-testid="lien-message" /></FormField>
                <input type="text" name="website" tabIndex={-1} autoComplete="off" value={f.website} onChange={(e) => set("website", e.target.value)} style={{ position: "absolute", left: -9999, opacity: 0 }} aria-hidden="true" />
                <label style={{ display: "flex", gap: 8, marginTop: 14, fontSize: 11, color: C.mid, lineHeight: 1.5, cursor: "pointer" }}>
                  <input type="checkbox" checked={f.rgpd} onChange={(e) => set("rgpd", e.target.checked)} style={{ width: 16, height: 16, flexShrink: 0, accentColor: C.gold }} data-testid="lien-rgpd" />
                  <span>{c.rgpd}</span>
                </label>
                <Btn variant="gold" disabled={!ok || saving} onClick={submit} style={{ width: "100%", marginTop: 16, padding: 12, fontSize: 14 }} data-testid="lien-envoyer">{saving ? "…" : "Envoyer ma demande"}</Btn>
                <div style={{ fontSize: 11, color: C.muted, marginTop: 8, textAlign: "center" }}>Téléphone ou e-mail : au moins un des deux.</div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
